// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusAddressDetailsStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails";
import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

orderStatusAddressDetailsStyles.wrapper = {
    css: css`
        display: flex;
        gap: 12px;

        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};
orderStatusAddressDetailsStyles.shippingAddressWrapper = {
    css: css`
        order: 2;
        width: 50%;
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

orderStatusAddressDetailsStyles.billingAddressWrapper = {
    css: css`
        order: 1;
        width: 50%;
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
orderStatusAddressDetailsStyles.titleText = {
    ...xOrderInformationStyles.address?.heading,
};
